import { useSelector } from 'react-redux';

const CallGroupStats = () => {
    const { metrics, metricsLoading } = useSelector(state => ({
        metrics: state.callGroupList.metrics,
        metricsLoading: state.callGroupList.metricsLoading,
    }));


 const displayMetrics = metrics || {
      totalCallGroups: 0,
      totalRankedActivityCount: 0,
      totalActivityCount: 0,
      totalRankedCallGroups: 0,
  };

    const summaryRows = [
        { label: "Total Call Groups:", value: displayMetrics.totalCallGroups },
        { label: "Ranked Call Groups:", value: displayMetrics.totalRankedCallGroups },
        { label: "Total Activities:", value: displayMetrics.totalActivityCount },
        { label: "Ranked Activities:", value: displayMetrics.totalRankedActivityCount },
      ];
  return (
    <div style={{ width: "280px" }}>
      <h5 className="text-primary text-center">Call Group & Activity Summary</h5>
        <ul className="list-group list-group-flush">
        {summaryRows.map((item, idx) => (
          <li key={idx} className="list-group-item d-flex justify-content-between py-1 px-2">
            <span className="me-2 flex-shrink-0" style={{ minWidth: "140px" }}>{item.label}</span>
            <strong className="text-end font-monospace">{metricsLoading ? "Loading..." : item.value}</strong>
          </li>
        ))}
        </ul>
      </div>
  );
};

export default CallGroupStats;